<template>
    <main class="home" id="mainContent">
        <h1 class="sr-only">{{ screenData.title }}</h1>
        <p>{{ screenData.description }}</p>
        <span class="google-translate">
            <a :href="translateweburl" target="_blank" class="translate">Translate to other languages</a>
        </span>
        <HomeAction />
    </main>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import appConfig from '@/app.config';
import HomeAction from "@/components/home/HomeAction.vue";
import { useHead } from '@unhead/vue'

// Use unhead to manage the page meta
useHead({
  title: `Home | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: appConfig.description
    }
  ]
})

// Vuex store
const store = useStore();

// Reactive data refs
const screenData = ref({});
const translateweburl = window.config.TRANSLATE_WEB_URL;

// Computed props
const STEPS = computed(() => store.state.user.STEPS);

// Lifecycle hooks
onMounted(() => {
  screenData.value = STEPS.value[0];
  localStorage.clear();
});
</script>


<style scoped lang="scss">
  .home {
    // compensate svg subpixel rendering (white top line and sides)
    background-image: url("~@ridmv/web-themes/images/img_hero.svg"), url("~@ridmv/web-themes/images/img_hero_subpixel.png");
    background-position: center top, center top;
    background-repeat: no-repeat, no-repeat;
    padding: 0 var(--padding-horizontal) calc(var(--padding-vertical) * 2);

    p {
       color: white;
       @extend %font-serif-bold;
       font-size: clamp(1.25rem, 8vw, 2.625rem);
       line-height: 1.25em;
       padding: clamp(1em, 4vw, 5rem) 0;
       text-align: center;
    }

    .google-translate {
       display: block;
       text-align: center;
       position: absolute;
       left: 42%;
       margin-top: -40px;
    }

    .translate {
       color: var(--ri-orange);
       position: relative;
       font-size: 18px;
       font-weight: bold;
    }
  }
  @media only screen and (min-width: 1901px) {
    .home {
      background-size: contain;
    }
  }
  @media only screen and (max-width: 450px) {
    .home {
      padding: 0 calc(var(--padding-horizontal) * 0.5) calc(var(--padding-vertical) * 2);
    }
  }
  @media only screen and (max-width: 600px) {
    .google-translate {
      margin-top: -25px !important;
      left: 16% !important;
    }
  }

  @media only screen and (min-width: 600px) and (max-width: 900px) {
    .google-translate {
      margin-top: -25px !important;
      left: 30% !important;
    }
  }
</style>
